import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { api } from "../../../../../services/Api";

export default function AutocompleteEstoquesTransferencia({
  value,
  onChange,
  required = false,
  idUnidade = "",
  disabled = false,
  ...rest
}) {
  const [estoques, setEstoques] = useState([]);

  useEffect(() => {
    onChange({
      id: "",
      nome: "",
    });
    async function buscarTodosEstoques() {
      try {
        const unidade_id = idUnidade;

        const { data } = await api.get(
          `/v2/almoxarifado/estoques/${unidade_id}`
        );

        const arrayComTodos = [...data.estoques];
        setEstoques(arrayComTodos);
      } catch (e) {
        console.log(e);
      }
    }

    buscarTodosEstoques();
  }, [idUnidade]);

  return (
    <Autocomplete
      {...rest}
      value={value}
      onChange={(event, value) => onChange(value)}
      disablePortal
      disableClearable
      disabled={disabled}
      id="combo-box-demo"
      options={estoques}
      getOptionLabel={(option) => option.nome}
      fullWidth
      renderInput={(params) => (
        <TextField
          required={required}
          variant="standard"
          {...params}
          label="Estoques"
        />
      )}
    />
  );
}
